import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { AdditionalFacilitiesFormFields } from 'src/@types';
import { additionalFacilitiesFormFields } from '../config';
import { FormElementDynamicInputTyped } from '../../../../shared/form-elements';

export const AdditionalFacilitiesDisabilityWiaExcessSection = ({
  register,
  values,
  errors
}: {
  register: UseFormRegister<AdditionalFacilitiesFormFields>;
  errors: FieldErrors<AdditionalFacilitiesFormFields>;
  values: AdditionalFacilitiesFormFields;
}) => {
  return (
    <>
      <Box>
        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'haveYouTakenOutTheWiaExcessInsurance'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        {values.haveYouTakenOutTheWiaExcessInsurance === 'true' && (
          <Box>
            <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
              formFields={additionalFacilitiesFormFields}
              id={'durationOfTheWiaExcessInsuranceStatement'}
              register={register}
              errors={errors}
              values={values}
              options={{ optionalStyle: true, required: true }}
            />

            {values.durationOfTheWiaExcessInsuranceStatement === 'Other' && (
              <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
                formFields={additionalFacilitiesFormFields}
                id={'durationOfTheWiaExcessInsuranceStatementOther'}
                register={register}
                errors={errors}
                values={values}
                options={{ optionalStyle: true, required: true }}
              />
            )}

            <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
              formFields={additionalFacilitiesFormFields}
              id={'theCoveragePercentageOfTheWiaExcessInsurance'}
              register={register}
              errors={errors}
              values={values}
              options={{ optionalStyle: true, required: true }}
            />

            {values.theCoveragePercentageOfTheWiaExcessInsurance === 'Other' && (
              <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
                formFields={additionalFacilitiesFormFields}
                id={'theCoveragePercentageOfTheWiaExcessInsuranceOther'}
                register={register}
                errors={errors}
                values={values}
                options={{ optionalStyle: true, required: true }}
              />
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
